export default "__VITE_ASSET__BzuKtrt0__"